import React from "react";
import { useDispatch } from "react-redux";
import { sidebarOpen } from "../../../../redux/reducers/sidebarReducer";
import { DASHBOARD_SIDEBAR_TYPES } from "../DashboardSidebar";
import { Button } from "@mui/material";
import { AddOutlined } from "@mui/icons-material";

const SidebarAddBorrowerBankInfoButton = ({
  children = "Add Bank Information",
}) => {
  const dispatch = useDispatch();

  const handleOnClick = () => {
    dispatch(
      sidebarOpen(
        DASHBOARD_SIDEBAR_TYPES.ADD_BORROWER_BANK_INFO, // type
      ),
    );
  };

  return (
    <Button
      startIcon={<AddOutlined className="thin" />}
      onClick={handleOnClick}
    >
      {children}
    </Button>
  );
};

export default SidebarAddBorrowerBankInfoButton;
